import { GameConstants } from './../../../GameConstants';
import { GameVars } from "../../../GameVars";

export class AvatarSpine extends Phaser.GameObjects.Container {

    private spine: any;
    private currentState: string;
    private currentStateNumber: number;
    private id: string;

    private winCount: number;

    constructor(scene: Phaser.Scene, x: number, y: number, id: string) {

        super(scene);

        this.x = x;
        this.y = y;

        this.id = id;

        this.winCount = 0;

        this.spine = (this.scene.add as any).spine(0, 0, id);
        this.spine.skeleton.setToSetupPose();
        this.add(this.spine);

        this.spine.setScale(GameVars.scaleX, GameVars.scaleY);

        this.currentState = "neutro";
        this.currentStateNumber = 2;
        this.spine.play(this.currentState);
        this.spine.setAnimation(1, "respiracion", true);

        this.spine.state.listeners[0].complete = (trackIndex: any) => {
            if (trackIndex.animation.name === "bucle-enfado" ||  
                trackIndex.animation.name === "check") {
                    this.spine.play(this.currentState);
            }  else if (trackIndex.animation.name === "blink" || 
                trackIndex.animation.name === "blink-contento" || 
                trackIndex.animation.name === "blink-enfado" || 
                trackIndex.animation.name === "tic") {
                    this.spine.clearTrack(2);
            } else if (trackIndex.animation.name === "tic-sudor") {
                this.spine.clearTrack(3);
            } else if (trackIndex.animation.name === "bucle-contento") {
                if (this.winCount === 0) {
                    this.winCount++;
                    this.setTempState("bucle-contento");
                } else {
                    this.winCount = 0;
                    this.spine.play(this.currentState);
                }
            }
        };

        this.spine.state.listeners[0].event = (trackIndex: any, event: any) => {
            if (event.data.name === "") {
                // 
            }          
        };

        this.setMixes();

        this.scene.sys.updateList.add(this);

    }

    public preUpdate(): void {

        let rand = Math.round(Math.random() * 1000);

        if (rand === 1) {
            this.animationBlink();
        } 
    }

    public clearTrack(index: number): void {

        this.spine.clearTrack(index);
    }

    public animationBlink(): void {

        if (this.id === "demon") {

            if (this.currentState === "contento2") {
                this.setAvatarAnimation(2, "blink-contento");
            } else if (this.currentState === "contento1" || this.currentState === "neutro") {
                this.setAvatarAnimation(2, "blink");
            } else {
                this.setAvatarAnimation(2, "blink-enfado");
            }

        } else {
            this.setAvatarAnimation(2, "blink");
        }
    }

    public calculateAvatarState(chips: number): void {

        let average = Math.round((GameConstants.ROOM_PRICE * (GameConstants.ADVERSARYS_LENGTH + 1)) / GameVars.gameState.players.length);

        if (chips < average / 4) {
            if (this.currentState !== "enfado2") {
                this.setAvatarState("enfado2");
                this.currentStateNumber = 0;
            }
        } else if (chips < average / 2) {
            if (this.currentState !== "enfado1") {
                this.setAvatarState("enfado1");
                this.currentStateNumber = 1;
            }
        } else if (chips < average * 1.5) {
            if (this.currentState !== "neutro") {
                this.setAvatarState("neutro");
                this.currentStateNumber = 2;
            }
        } else if (chips < average * 2.5) {
            if (this.currentState !== "contento1") {
                this.setAvatarState("contento1");
                this.currentStateNumber = 3;
            }
        } else {
            if (this.currentState !== "contento2") {
                this.setAvatarState("contento2");
                this.currentStateNumber = 4;
            }
        }
    }

    public setAvatarState(state: string, loop?: boolean): void {

        this.currentState = state;
        this.spine.play(state, loop || false);
    }

    public setTempState(state: string): void {

        this.spine.play(state);
    }

    public setAvatarAnimation(index: number, anim: string): void {

        try {
            this.spine.setAnimation(index, anim);
        } catch (error) {
            // 
        }
    }

    public winAnimation(): void {

        this.setTempState("bucle-contento");

        if (this.id === "burger-teen" || this.id === "moai") {
            this.setAvatarAnimation(2, "saltito");
            this.setAvatarState(GameConstants.BOT_STATES[this.currentStateNumber === GameConstants.BOT_STATES.length - 1 ? GameConstants.BOT_STATES.length - 1 : this.currentStateNumber + 1]);
            this.scene.time.addEvent({delay: 2000 / GameVars.gameSpeed, callback: () => {
                this.setAvatarState(GameConstants.BOT_STATES[this.currentStateNumber]);
            }, callbackScope: this});
        }
    }

    public checkAnimation(): void {

        this.setTempState("check");
    }

    public bluffAnimation(): void {

        if (this.id === "burger-teen" || this.id === "monkey" || this.id === "richMan" || this.id === "zombie") {
            this.setAvatarAnimation(2, "tic");
        } else if (this.id === "moai") {
            this.setAvatarAnimation(2, "brillos");
        }
    }

    private setMixes(): void {

        let states = ["contento2", "contento1", "neutro", "enfado1", "enfado2"];
        let tempStates = ["bucle-enfado", "bucle-contento"];

        for (let i = 0; i < states.length - 1; i++) {

            this.spine.setMix(states[i], states[i + 1], .25);
            this.spine.setMix(states[i + 1], states[i], .25);
        }

        for (let i = 0; i < states.length; i++) {
            for (let j = 0; j < tempStates.length; j++) {
                this.spine.setMix(states[i], tempStates[j], .25);
                this.spine.setMix(tempStates[j], states[i], .25);
            }
        }
    }
}
